/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React from 'react';

import { Container } from './styled';

import { withFocusable } from '@noriginmedia/react-spatial-navigation';

export default withFocusable({
  trackChildren: true,
})(function ModalWrapper({ children, opened }: { children?: React.ReactNode; opened?: boolean }) {
  return (
    <>
      <Container opened={opened}>{children}</Container>
    </>
  );
});
